import { WaterFinalInvoiceServiceService } from '../services/water-final-invoice-service.service';
import { WaterFinalInvoiceService } from '@app/services/water-final-invoice/classes/water-final-invoice-service';
import { createServiceStoreFactory } from '@app/services/base/store/create-service-store-factory';

export const WaterFinalInvoiceServiceStore = createServiceStoreFactory(
    'WaterFinalInvoice',
    WaterFinalInvoiceService,
    WaterFinalInvoiceServiceService,
);
